/**
 * Styled Components - Created by miguelcanobbio on 23/08/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 14px 26px 0px 26px;
  ${({ isExternal }: { isExternal?: boolean }) => isExternal ? `
    @media (max-width: 1440px) {
      .areaLabel {
        margin-left: -6px;
        font-size: 11.5px;
      }
    }
  ` : ''}
  @media (max-width: 1360px) {
    padding: 14px 14px 0px 14px;
  }

  @media (min-width: 768px) and (max-width: 991px) {
    flex-wrap: wrap;
    padding: 10px 0px 15px 15px;
  }
`

export const ShuffleButton = styled.div`
  cursor: pointer;
`

export const Icon = styled.img`
  width: 24px;
  object-fit: contain;
  opacity: 50%;
  padding-top: 8px;
`

export const RightButtons = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
`

export const SavePalette = styled.div`
  margin-top: 15px;
  font-size: 11.5px;
  margin-bottom: -4px;
  color: cornflowerblue;
  border: 1px solid cornflowerblue;
  padding: 0 4px;
  margin-left: -2px;
  margin-right: -2px;
  border-radius: 3px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: cornflowerblue;
    color: white;
  }
  @media (max-width: 1200px) {
    max-width: 54px;
    text-align: center;
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/ColorButtons/styledComponents.tsx